import {
  getEventIds,
  getEventIdUsingTemplate,
  getEventsOptions,
  getRetentionComplexIdUsingTemplate,
  getRetentionComplexOptions,
  getUsersIdUsingTemplate,
} from '../../reducers/analyticsApp';
import { toRetentionQuery } from '../../converters/retentionConverter';
import { buildQueries } from '../../actions/common';
import {
  EVENT_TEMPLATE_TYPE,
  RETENTION_TEMPLATE_TYPE,
  USER_TEMPLATE_TYPE,
} from '../../constants/dashboards';
import EventTemplateBuilder from './EventTemplateBuilder';
import UserTemplateBuilder from './UserTemplateBuilder';
import RetentionTemplateBuilder from './RetentionTemplateBuilder';
import { createQuery } from '../../utils/event/createQueries';
import { createComplexQuery } from '../../converters/retentionApiConverter';
import { buildUsersQuery } from '../../converters/usersApiConverter';

const composeRetentionTemplate = (state, templateName, templateDescription, type) =>
  RetentionTemplateBuilder.builder()
    .id(getRetentionComplexIdUsingTemplate(state))
    .name(templateName)
    .description(templateDescription)
    .type(type)
    .showAverage(getRetentionComplexOptions(state).averageLine)
    .showMedian(getRetentionComplexOptions(state).medianLine)
    .retentionQuery({ query: toRetentionQuery(createComplexQuery(state)) })
    .build();

const composeUsersTemplate = (state, templateName, templateDescription, type) =>
  UserTemplateBuilder.builder()
    .id(getUsersIdUsingTemplate(state))
    .name(templateName)
    .description(templateDescription)
    .type(type)
    .queries({ query: buildUsersQuery(state) })
    .build();

const createQueries = (state) => {
  const ids = getEventIds(state);

  return ids.map((id) => createQuery(state, id));
};

const composeEventTemplate = (state, templateName, templateDescription, type) =>
  EventTemplateBuilder.builder()
    .id(getEventIdUsingTemplate(state))
    .name(templateName)
    .description(templateDescription)
    .type(type)
    .formula(getEventsOptions(state).enteredFormula)
    .multiqueryMode(getEventsOptions(state).singleChartMode)
    .sortingAxis(getEventsOptions(state).columnChartSorting.axis)
    .sortingOrder(getEventsOptions(state).columnChartSorting.order)
    .showAverage(getEventsOptions(state).averageLine)
    .showMedian(getEventsOptions(state).medianLine)
    .showGrandTotal(getEventsOptions(state).calcTotal)
    .queries(
      buildQueries(state, (stateParam) => createQueries(stateParam).map((q) => ({ query: q })))
    )
    .build();

const TemplateComposer = (state, templateName, templateDescription, type) => {
  switch (type) {
    case EVENT_TEMPLATE_TYPE:
      return composeEventTemplate(state, templateName, templateDescription, type);

    case USER_TEMPLATE_TYPE:
      return composeUsersTemplate(state, templateName, templateDescription, type);

    case RETENTION_TEMPLATE_TYPE:
      return composeRetentionTemplate(state, templateName, templateDescription, type);

    default:
      return undefined;
  }
};

export default TemplateComposer;
